module.exports = __webpack_public_path__ + "static/media/adversity.6b92e17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/adversity.png
// module id = 51
// module chunks = 0